
import { Component, Mixins, Prop } from 'vue-property-decorator'

import LocaleMixin from '@/mixins/LocaleMixin'
import { TGenericObject } from '@/types/base'

@Component({
  name: 'showcase-project-card'
})
export default class GenericCard extends Mixins(LocaleMixin) {
  @Prop() title!: string
  @Prop() viewBtnText!: string
  @Prop() subTitle: { firstLine: string, secondLine: string }
  @Prop() imageSrc: string
  @Prop() customBtnStyle: TGenericObject
  @Prop({ required: false }) affiliateParam: string

  get openLinkInNewTab (): boolean {
    /* eslint-disable object-shorthand */
    return this.$route.query?.widget === 'true' || this.$route.path.endsWith('/widget/')
  }

  cardClicked (): void {
    this.$emit('card-clicked')
  }

  truncate (title: string, length: number): string {
    if (title.length > length) {
      return `${title.slice(0, length - 3)} ...`
    }
    return title
  }
}
